RivalIQ.module('utils', function (utils, App, Backbone, Marionette, $, _) {

    'use strict';

    const createStatus = utils.createStatus = {};

    createStatus.stillFinding = function (createStatus) {

        if (!createStatus) {
            return true;
        }
        return !((createStatus.startedAt && createStatus.finishedAt) || (!createStatus.startedAt && createStatus.finished));
    };

});
